var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","current-page":_vm.pageNo,"page-sizes":[10, 20, 40],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }